import React from 'react';
import PropTypes from 'prop-types';
import { Typo } from '@ers/ui';
import BaseAvatar from './BaseAvatar';
import Types from './AvatarTypes';


const ThreadAvatar = ({ isRead, children }) => (
    <BaseAvatar
        type={Types.Thread} text={children}
    >
        { (initials) => (
            <>
                {!isRead && <div className="avatar__read" />}
                <Typo.Avatar.Thread>{initials}</Typo.Avatar.Thread>
            </>
        )}
    </BaseAvatar>
);


ThreadAvatar.propTypes = {
    children: PropTypes.node.isRequired,
    isRead: PropTypes.bool.isRequired
};


export default ThreadAvatar;